import cx from 'classnames'
import { RawButton } from '@/components/Button'
import { OrganizerStep } from '@/features/jobs/details/tax-type/tax-prep-organizer/TaxPrepOrganizerViewModel'
import styles from './StepNavigation.module.css'

interface Step {
  id: OrganizerStep
  label: string
  number: number
}

const steps: Step[] = [
  { id: OrganizerStep.Personal, label: 'Personal', number: 1 },
  { id: OrganizerStep.Business, label: 'Business', number: 2 },
  { id: OrganizerStep.Rental, label: 'Rental', number: 3 },
]

interface StepNavigationProps {
  activeStep: OrganizerStep
  onStepChange: (step: OrganizerStep) => void
  testId?: string
}

export function StepNavigation({
  activeStep,
  onStepChange,
  testId,
}: StepNavigationProps) {
  return (
    <nav className={styles.stepNavigation} data-test={testId}>
      <ol className={styles.stepList}>
        {steps.map((step, index) => (
          <li key={step.id} className={styles.stepItem}>
            <RawButton
              onPress={() => onStepChange(step.id)}
              className={({ isFocusVisible }) =>
                cx(
                  styles.stepButton,
                  activeStep === step.id && styles.active,
                  isFocusVisible && styles.focusVisible,
                )
              }
              testId={testId ? `${testId}-${step.id}` : undefined}
            >
              <span className={styles.stepNumber}>{step.number}</span>
              <span>{step.label}</span>
            </RawButton>
            {index < steps.length - 1 && (
              <div className={styles.stepConnector} />
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
